import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import HotWorksList from "./components/HotWorksList";
import CategoryNav from "./components/CategoryNav";
import NewsCard from "@/components/base/NewsCard";
import PlotCard from "@/components/base/PlotCard";
import { getHotWorks, getLatestNews, getLatestPlots } from "@/lib/content";

export default function Home() {
  const latestNews = getLatestNews(5);
  const featuredPlots = getLatestPlots(3);
  const hotWorks = getHotWorks(5);

  return (
    <div className="hp-fade-up">
      <HeroCarousel />
      <CategoryEntries />

      <section className="w-full px-4 md:px-6 pb-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-5">
              <div>
                <h2 className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
                  最新影视资讯
                </h2>
                <p className="text-sm text-foreground-500 mt-1.5">
                  按发布时间倒序，掌握影视行业最新动态
                </p>
              </div>
              <Link
                to="/category/news"
                className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
              >
                查看更多
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="space-y-3">
              {latestNews.map((item) => (
                <NewsCard key={item.id} item={item} layout="row" />
              ))}
            </div>
            <Link
              to="/category/news"
              className="sm:hidden inline-flex items-center justify-center gap-1 w-full mt-4 text-sm text-primary-600 whitespace-nowrap"
            >
              查看更多资讯
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <aside className="space-y-6">
            <HotWorksList items={hotWorks} />
            <CategoryNav />
          </aside>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-5">
          <div>
            <h2 className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
              精选剧情解析
            </h2>
            <p className="text-sm text-foreground-500 mt-1.5">
              结局拆解、伏笔盘点与人物深读，一次看懂好故事
            </p>
          </div>
          <Link
            to="/category/plot"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            全部解析
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredPlots.map((item) => (
            <PlotCard key={item.id} item={item} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-6 pb-4">
        <div className="rounded-lg bg-secondary-50 border border-secondary-200 p-8 md:p-10 grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
          <div className="lg:col-span-2">
            <h2 className="font-heading font-black text-2xl md:text-3xl text-foreground-950 mb-4">
              关于黑皮辣妹影视频道
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              我们是一个专注影视资讯、剧情解析与作品资料的垂直内容频道。
              从热门新片到冷门佳作，从定档消息到结局拆解，我们为每一位影迷提供
              及时、深入、好读的影视内容。无论你是追剧党还是影评爱好者，
              都能在这里找到想看的故事。
            </p>
            <div className="flex items-center gap-3 mt-6 flex-wrap">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-medium px-5 py-2.5 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解我们
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 border border-foreground-300 text-foreground-800 text-sm font-medium px-5 py-2.5 rounded-md hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                联系我们
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-3 lg:grid-cols-1 gap-4">
            {[
              { num: "12+", label: "收录作品" },
              { num: "9+", label: "资讯速递" },
              { num: "6+", label: "深度解析" },
            ].map((stat) => (
              <div key={stat.label} className="rounded-lg bg-background-50 border border-secondary-200 px-4 py-3 text-center lg:text-left">
                <div className="font-label font-bold text-2xl text-primary-600">{stat.num}</div>
                <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}